import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface ChannelListIsOnlineHeaderProps
  extends HeaderContext<
    GatewayChannelWithChargePointInfoModel,
    GatewayChannelWithChargePointInfoModel['isOnline']
  > {}

export const ChannelListIsOnlineHeader =
  () // props: ChannelListIsOnlineHeaderProps,
  : ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    // Nothing to do

    // RENDER ////////////////////////////////////////////////////////////////////

    return <Icon name="wifi" />;
  };
